module.exports = "/lucky-balls/img/bonus_yellow/header_dualsoft.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/header_dualsoft.png
// module id = 965
// module chunks = 0